import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import type { SxProps } from '@mui/system';


interface AvatarWithLoaderProps {
  src: string;
  sx?: {
    width?: string | number;
    height?: string | number;
    [key: string]: any; // To allow other styles
  };
}

const AvatarWithLoader: React.FC<AvatarWithLoaderProps> = ({ src, sx }) => {
  const [isLoading, setIsLoading] = useState(true);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    setIsLoading(false); // Handle errors if necessary
  };

  return (
    <Box
      sx={{
        position: 'relative',
        width: sx?.width ? sx?.width : '100%',
        height: sx?.height ? sx?.height : '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      {isLoading && (
        <CircularProgress
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      )}
      <Avatar
        src={src}
        sx={{
          ...sx, // Apply passed styles for avatar
          display: isLoading ? 'none' : 'block', // Hide while loading
          position: isLoading ? 'absolute' : 'relative', // Absolute for loader scenario
          top: isLoading ? '50%' : undefined,
          left: isLoading ? '50%' : undefined,
          transform: isLoading ? 'translate(-50%, -50%)' : undefined,
        }}
        onLoad={handleImageLoad}
        onError={handleImageError}
      />
    </Box>
  );
};

export default AvatarWithLoader;
